// API Configuration
const config = {
  // In production (Vercel), API routes are at /api
  // In development, use localhost:3001
  apiUrl: process.env.NODE_ENV === 'production' 
    ? '/api' 
    : 'http://localhost:3001/api',
};

export default config;
